import { myFetch, HttpMethod } from './baseService';

// ==================== INTERFACES ====================

export interface Encomienda {
  enc_codigo: string | number;
  enc_foto_base64?: string;
  enc_ruta_foto?: string;
  apt_codigo: string;
  apt_nombre: string;
  tor_codigo: string;
  tor_nombre: string;
  ten_codigo: string;
  ten_nombre: string;
  enc_nombre_mensajero: string;
  enc_fecha_recibido: string;
  enc_hora_recibido?: string;
  een_codigo: string;
  een_nombre: string;
  enc_fecha_entregado?: string;
  enc_hora_entregado?: string;
  usu_recibio_nombre?: string;
  // Campos adicionales de la respuesta del API
  enc_torre?: string;
  enc_torre_nombre?: string;
  enc_apartamento?: string;
  enc_apartamento_nombre?: string;
  enc_tipo?: string;
  enc_tipo_nombre?: string;
  enc_estatus?: string;
  enc_estatus_nombre?: string;
  enc_recibido_por?: string;
  enc_recibido_por_nombre?: string;
  enc_unidad_residencial?: string;
  enc_unidad_residencial_nombre?: string;
}

export interface ObtenerEncomiendas {
  unidad_residencial_codigo: string;
  torre_codigo?: string;
  apartamento_codigo?: string;
  estatus_codigo?: string;
  encomienda_codigo?: string;
}

export interface InsertarEncomienda {
  recibido_por_codigo: string;
  nombre_mensajero: string;
  apartamento_codigo: string;
  tipo_codigo: string;
  foto_base64: string;
}

export interface ModificarEncomienda {
  codigo: string;
  nombre_mensajero: string;
  apartamento_codigo: string;
  tipo_codigo: string;
}

export interface ModificarFotoEncomienda {
  codigo: string;
  foto_base64: string;
}

export interface CambiarAEntregado {
  codigo: string;
}

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// ==================== FUNCIONES ====================

/**
 * Obtener todas las encomiendas según filtros
 */
export const obtenerEncomiendas = async (payload: ObtenerEncomiendas) => {
  const envelope = await myFetch<ApiEnvelope<Encomienda[]>>(
    'encomienda/ObtenerTodos',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Insertar nueva encomienda
 */
export const insertarEncomienda = async (payload: InsertarEncomienda) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'encomienda/Insertar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Modificar datos de encomienda
 */
export const modificarEncomienda = async (payload: ModificarEncomienda) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'encomienda/modificar',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Modificar foto de encomienda
 */
export const modificarFotoEncomienda = async (payload: ModificarFotoEncomienda) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'encomienda/Modificar_foto',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

/**
 * Marcar encomienda como entregada
 */
export const cambiarAEntregado = async (payload: CambiarAEntregado) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    'encomienda/cambiar_a_entregado',
    HttpMethod.POST,
    payload
  );
  return envelope;
};

